<template>
    <el-card>

        <div slot="header">
            <el-row type="flex" justify="space-between" style="margin-bottom: 0">
                <h3>Einstellungen für <span v-if="supplierName">{{ supplierName }}</span></h3>
                <el-button type="text" @click="$emit('canceled')">Schliessen</el-button>
            </el-row>
        </div>

        <el-form v-if="supplierSettings" ref="supplierSettings" :model="supplierSettings" label-width="300px" label-position="left">
            <el-form-item
                v-for="key in Object.keys(Object.assign({}, supplierSettings)).filter(key => key !== 'supplier_id')"
                :key="key"
                :label="parseLabel(key)"
                :prop="key"
            >
                <el-input
                    v-if="key !== 'supplier_id' && key !== 'order_additonal_field'"
                    v-model="supplierSettings[key]">
                    {{key}}
                </el-input>

                <div v-if="key === 'order_additonal_field'">
                    <el-tag
                        :key="tag"
                        v-for="tag in orderAdditionalOptions"
                        closable
                        :disable-transitions="false"
                        @close="handleDeleteOption(tag)">
                        {{tag}}
                    </el-tag>
                    <el-input
                        class="input-new-tag"
                        v-if="newOptionVisible"
                        v-model="newOptionValue"
                        ref="saveNewOptionInput"
                        size="mini"
                        @keyup.enter.native="handleCreateOption"
                        @blur="handleCreateOption"
                    >
                    </el-input>
                    <el-button v-else class="button-new-tag" size="small" @click="showNewOption">+ New Tag</el-button>
                </div>


            </el-form-item>

            <el-form-item>
                <el-button
                        :disabled="loading"
                        type="primary" @click="submitForm('supplierSettings')">Bestätigen
                </el-button>
                <el-button
                        :disabled="loading"
                        @click="$emit('canceled')">Abbrechen
                </el-button>
            </el-form-item>
        </el-form>
    </el-card>
</template>

<script>

    import { mapGetters } from 'vuex';
    import { UPDATE_SUPPLIER_SETTINGS } from '../../../store/types';

    export default {
        name: 'SettingsForm',
        props: {
            supplierId: {
                type: Number,
            },
        },
        computed: {
            ...mapGetters(['get_supplier']),
        },
        data () {
            return {
                loading: false,
                supplierName: '',
                supplierSettings: null,
                orderAdditionalOptions: [],
                newOptionVisible: false,
                newOptionValue: '',
            };
        },
        created () {
            const supplier = this.$parent.getSelectedSupplier();

            if (supplier.settings.order_additonal_field) {
                this.orderAdditionalOptions = supplier.settings.order_additonal_field.split('|');
            }

            this.supplierSettings = supplier.settings;
            this.supplierName = supplier.supplier_name;
        },
        methods: {
            submitForm (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        this.$store.dispatch(UPDATE_SUPPLIER_SETTINGS, this.supplierSettings).then((resp) => {
                            this.$message.success(resp.message);
                            this.$emit('canceled');
                            this.loading = false;
                        }).catch((resp) => {
                            this.$message.error(resp.message);
                        });
                    }
                });
            },
            parseLabel (key) {
                const label = key.replace(/_/g, ' ');
                return label;
            },
            showNewOption () {
                this.newOptionVisible = true;
                this.$nextTick(() => {
                    this.$refs.saveNewOptionInput[0].$refs.input.focus();
                });
            },
            handleDeleteOption (option) {
                this.orderAdditionalOptions.splice(this.orderAdditionalOptions.indexOf(option), 1);
                this.supplierSettings.order_additonal_field = this.orderAdditionalOptions.join('|');
            },
            handleCreateOption () {
                const inputValue = this.newOptionValue;
                if (inputValue) {
                    let prefix = '|';
                    if (this.orderAdditionalOptions.length === 0) {
                        this.supplierSettings.order_additonal_field = '';
                        prefix = '';
                    }
                    this.orderAdditionalOptions.push(inputValue);
                    this.supplierSettings.order_additonal_field += `${prefix}${inputValue}`;
                }
                this.newOptionVisible = false;
                this.newOptionValue = '';
            },
        },
    };
</script>

<style lang="scss" scoped>
.el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/suppliers/SettingsForm.vue